import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Paths from "@/constants/paths";

export const LogoutHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = () => {
      navigate(Paths.auth.login);
    };

    window.addEventListener("logout", handleLogout);

    return () => {
      window.removeEventListener("logout", handleLogout);
    };
  }, [navigate]);

  return null; // This component doesn't render anything
};
